import { createContext } from "react";

// Dark mode has been removed — the app is a single light theme ("Blue · Light"
// per the RABS Workspace spec). ThemeContext is kept (with darkMode permanently
// false + a no-op setter) so any remaining consumers don't break, and
// useThemeColors returns the light palette only.
export const ThemeContext = createContext({
  darkMode: false,
  setDarkMode: () => {},
});

function ThemeProvider({ children }) {
  return (
    <ThemeContext.Provider value={{ darkMode: false, setDarkMode: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
}

// Light-only palette. Keys are unchanged so existing `colors.*` callers keep
// working; for spec UI prefer importing from theme/tokens.js directly.
export function useThemeColors() {
  return {
    darkMode: false,
    bg:               "#f9fafb",
    cardBg:           "rgba(255, 255, 255, 0.72)",
    menuBg:           "#ffffff",
    cardBorder:       "rgba(15, 23, 42, 0.08)",
    cardBorderHover:  "rgba(129, 140, 248, 0.40)",
    text:             "#111827",
    textMuted:        "#6b7280",
    textFaint:        "#9ca3af",
    hover:            "rgba(243, 244, 246, 0.75)",
    divider:          "rgba(15, 23, 42, 0.06)",

    // Premium-glass tokens (still used by a few not-yet-flattened pages).
    glassBg:          "rgba(255, 255, 255, 0.65)",
    glassBgStrong:    "rgba(255, 255, 255, 0.85)",
    glassBorder:      "rgba(255, 255, 255, 0.80)",
    glassBorderHover: "rgba(129, 140, 248, 0.40)",
    shadowSm:         "0 4px 18px rgba(15, 23, 42, 0.06)",
    shadowLg:         "0 18px 44px rgba(15, 23, 42, 0.12)",
    blobA:            "rgba(99, 102, 241, 0.18)",
    blobB:            "rgba(168, 85, 247, 0.14)",
    blobC:            "rgba(16, 185, 129, 0.12)",
  };
}

export default ThemeProvider;
